import React, { useState, useEffect } from "react";
import { useUpdateRolePermissionMutation, useGetRoleByIdMutation } from "./Api";
import ToastrService from "../../services/toastService";
import Loader from "../loader/loader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GoPencil } from "react-icons/go";
import AddRoles from "./AddRoles";


const ManageRolesAndPermissions = () => {

  // const { id } = useParams();
  const location = useLocation();
  const id = location.state?.id;
  const navigate = useNavigate();

  const [
    updateRolePermissionApi,
    { isLoading: updateIsLoading }
  ] = useUpdateRolePermissionMutation();

  const [
    getRoleByIdApi,
    { isLoading }
  ] = useGetRoleByIdMutation();


  const [rolePermission, setRolePermission] = useState([]);
  const [roles, setRoles] = useState({});


  /*
   * Get role details
   */
  useEffect(() => {

    if (id) {
      getRolePermission();
    }

  }, [id]);


  const getRolePermission = async () => {

    try {

      const response = await getRoleByIdApi({
        id: Number(id)
      }).unwrap();

      console.log(
        "Get Role Response:",
        response
      );

      if (
        response?.data &&
        response.data.length > 0
      ) {

        const roleData = response.data[0];

        setRolePermission(
          roleData.role_permissions || []
        );

        setRoles(roleData);

      } else {

        ToastrService.error(
          "Role not found"
        );

        navigate("/roles");
      }

    } catch (err) {

      console.log(
        "Get role error:",
        err
      );

      ToastrService.error(
        err?.data?.message ||
        "Failed to retrieve role"
      );
    }
  };


  /*
   * Handle checkbox
   */
  const handleCheckboxChange = (index) => {

    setRolePermission(previousPermissions =>
      previousPermissions.map(
        (item, currentIndex) =>
          currentIndex === index
            ? {
              ...item,
              view: !item.view
            }
            : item
      )
    );
  };


  /*
   * Update permissions
   */
  const handleSubmit = async () => {

    try {

      if (!roles?.id) {

        ToastrService.error(
          "Role ID not found"
        );

        return;
      }

      const response =
        await updateRolePermissionApi({

          id: roles.id,

          role_permissions: rolePermission

        }).unwrap();


      console.log(
        "Update Response:",
        response
      );


      if (response?.success) {

        ToastrService.success(
          response.message ||
          "Role permission updated successfully"
        );

        navigate("/roles");

      }

    } catch (err) {

      console.log(
        "Update permission error:",
        err
      );

      ToastrService.error(
        err?.data?.message ||
        "Failed to update role permissions"
      );
    }
  };


  /*
   * Drawer
   */
  const [isDrawerOpen, setIsDrawerOpen] =
    useState(false);


  const handleUpdateUser = () => {

    setIsDrawerOpen(true);

  };


  const handleCloseDrawer = () => {

    setIsDrawerOpen(false);

  };


  const handleSave = (userData) => {

    console.log(
      "Updated role data:",
      userData
    );

    handleCloseDrawer();

    // Refresh role data
    getRolePermission();

  };


  return (

    <div>

      {isLoading || updateIsLoading ? (

        <Loader />

      ) : (

        <div>

          {/* Header */}

          <div className="page-header">

            <div className="page-header-left d-flex align-items-center">

              <ul className="breadcrumb mb-0">

                <li className="breadcrumb-item">
                  Roles & Permission Management
                </li>

                <li className="breadcrumb-item active">
                  Permissions
                </li>

              </ul>

            </div>

          </div>


          <div className="main-content">

            <div className="row">

              <div className="p-6">


                {/* Title */}

                <div
                  className="
                    d-flex
                    justify-content-between
                    align-items-center
                    mb-3
                  "
                >

                  <div>

                    <h3 className="h4 mb-1 drawer-header">

                      Roles & Permission

                    </h3>

                    <p className="mb-0 text-muted">

                      Manage Roles and Permissions.

                    </p>

                  </div>


                  <button
                    className="btn btn-primary"
                    onClick={handleSubmit}
                  >

                    Save

                  </button>

                </div>


                {/* Role Name */}

                <div className="mb-3">

                  <div
                    className="
                      d-flex
                      justify-content-between
                      align-items-start
                    "
                  >


                    <h6 className="mb-0">

                      <span className="text-primary">

                        Role name :

                      </span>

                      {" "}

                      {roles?.role_displayname}


                      <GoPencil

                        size={18}

                        style={{
                          cursor: "pointer",
                          marginLeft: "8px"
                        }}

                        onClick={handleUpdateUser}

                      />

                    </h6>


                    <span

                      style={{
                        cursor: "pointer",
                        color: "#0d6efd",
                        textDecoration: "underline",
                        fontSize: "14px"
                      }}

                      // onClick={() =>
                      //   navigate(
                      //     `/viewUsers/${roles?.id}`
                      //   )
                      // }
                      onClick={() =>
                        navigate("/viewUsers", {
                          state: { id: roles?.id },
                        })
                      }
                    >

                      View Users

                    </span>


                  </div>

                </div>


                {/* No Data */}

                {!isLoading &&
                  rolePermission?.length === 0 && (

                    <div className="no-data">

                      No data found

                    </div>

                  )}


                {/* Permission Table */}

                <div className="card p-3 mb-4">

                  <div className="table-responsive">


                    <table className="table table-hover mb-0">


                      <thead>

                        <tr>

                          <th>Module</th>

                          <th>Permission</th>

                        </tr>

                      </thead>


                      <tbody>


                        {!isLoading &&
                          rolePermission?.map(
                            (item, index) => (

                              <tr
                                key={item.module_id}
                              >


                                <td>

                                  {item.module_name}

                                </td>


                                <td>

                                  <input

                                    type="checkbox"

                                    checked={
                                      Boolean(item.view)
                                    }

                                    onChange={() =>
                                      handleCheckboxChange(
                                        index
                                      )
                                    }

                                    className="form-check-input"

                                    style={{
                                      height: "18px"
                                    }}

                                  />

                                </td>


                              </tr>

                            )
                          )}


                      </tbody>


                    </table>


                  </div>

                </div>


              </div>

            </div>

          </div>


          {isDrawerOpen && (

            <AddRoles

              mode="update"

              roleList={[]}

              onClose={handleCloseDrawer}

              onSave={handleSave}

              data={roles}

            />

          )}


        </div>

      )}

    </div>

  );

};


export default ManageRolesAndPermissions;